import Rollbar from 'rollbar'

import { getEnvFromUrl } from '@/utilities/env'

const ENV = getEnvFromUrl()

const rollbarConfig = {
  hostBlockList: ['localhost'],
  accessToken: 'ddbed3424ef84d5396ff2975aa4346b2',
  captureUncaught: true,
  captureUnhandledRejections: true,
  autoInstrument: {
    log: false,
  },
  payload: {
    environment: ENV,
    client: {
      javascript: {
        code_version: '1.0.0',
        source_map_enabled: true,
      },
    },
  },
}

export const rollbar = new Rollbar(rollbarConfig)

export const ignoredRollbarErrors = ['ResizeObserver loop']
